import React,{useState, useEffect} from 'react'
import sanityClient from '../client';
import { useTranslation } from "react-i18next";
import Slider from '../Components/Slider/Slider'
import Header from '../Components/Header/Header'

import Person from '../assets/aboutme/GuilleAlpha.png'

import './Home.css'
import Form from '../Components/Form/Form'

function Home() {
    const { t, i18n } = useTranslation();
    const [postInfo, setPostInfo] = useState(null);

    useEffect(() => {
        sanityClient.fetch(`*[_type == "info"]{
            title,
            body
        }`)
        .then((data) => setPostInfo(data))
        .catch(console.error);
    }, [])
    return (
        <>
            <Header />
            <Slider/>
            <div className="aboutme_container" id="aboutme">
                <img src={ Person } alt="img_person" className="img_person" />
                <div className="info" >
                    { i18n.language === "es" && postInfo ?
                        <>
                            <p className="title">Sobre mi</p>
                            {
                                postInfo.map((item) => (
                                    <p className="text" key={item.title.es}>{t("info.aboutme", {text: item.body.es })}</p>
                                ))
                            }
                                
                            
                        </>
                        :
                        <>
                            <p className="title">About me</p>
                            {postInfo &&
                                postInfo.map((item) => (
                                    <p className="text" key={item.title.en}>{t("info.aboutme", {text: item.body.en })}</p>
                                ))
                            }
                        </>
                    }
                    
                </div>
            </div>
            <Form />
        </>
    )
}

export default Home
